/**
 * Tiny fetch wrapper used by the code that ships in the main bundle
 * (SiteGate, Google-reviews pill, hero QuoteForm). It replaces axios there
 * so the ~13 KB (gzipped) axios runtime is only downloaded by the lazy
 * routes that still use it.
 *
 * Errors mimic the axios shape the call sites already handle:
 *   err.response = { status, data }   (HTTP error)
 *   err.code = "ECONNABORTED"          (timeout)
 */
class HttpError extends Error {
  constructor(message, response, code) {
    super(message);
    this.name = "HttpError";
    this.response = response;
    if (code) this.code = code;
  }
}

const parseBody = async (res) => {
  const text = await res.text();
  if (!text) return null;
  try {
    return JSON.parse(text);
  } catch {
    return text;
  }
};

const request = async (url, { method = "GET", body, timeout = 10000, withCredentials = false } = {}) => {
  const controller = typeof AbortController !== "undefined" ? new AbortController() : null;
  const timer = controller ? setTimeout(() => controller.abort(), timeout) : null;
  try {
    const res = await fetch(url, {
      method,
      headers: body !== undefined ? { "Content-Type": "application/json", Accept: "application/json" } : { Accept: "application/json" },
      body: body !== undefined ? JSON.stringify(body) : undefined,
      credentials: withCredentials ? "include" : "same-origin",
      signal: controller ? controller.signal : undefined,
    });
    const data = await parseBody(res);
    if (!res.ok) {
      throw new HttpError(`Request failed with status code ${res.status}`, { status: res.status, data });
    }
    return { data, status: res.status };
  } catch (err) {
    if (err && err.name === "AbortError") {
      throw new HttpError(`timeout of ${timeout}ms exceeded`, undefined, "ECONNABORTED");
    }
    throw err;
  } finally {
    if (timer) clearTimeout(timer);
  }
};

export const getJson = (url, opts) => request(url, { ...opts, method: "GET" });
export const postJson = (url, body, opts) => request(url, { ...opts, method: "POST", body });
